<template>
    <div id="waiting-area-add">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#waitingAreaAdd"
            @click="resetForm()"><i class="fas fa-plus"></i> Add</button>

        <!-- Modal -->
        <div class="modal fade text-left" id="waitingAreaAdd" tabindex="-1" aria-labelledby="waitingAreaAddLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="waitingAreaAddLabel">Add Waiting Area </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="alert.status" :class="getAlertClass()" role="alert">
                            <i :class="getAlertIcon()"></i> {{ alert.message }}
                        </div>
                        <form id="waiting-area-add-form" @submit.prevent>
                            <div class="form-group">
                                <label for="waitingArea">Waiting Area </label><small
                                    class="ml-1 font-weight-bold text-danger">*Required</small>
                                <input type="text" class="form-control form-control-sm" id="waitingArea"
                                    name="waitingArea" v-model="waitingArea" aria-describedby="waitingArea"
                                    placeholder="Please provide a waiting area">
                            </div>
                            <div class="form-group">
                                <label for="notes">Notes </label>
                                <textarea type="text" class="form-control form-control-sm" id="notes" name="notes"
                                    v-model="notes" aria-describedby="notes" rows="3"
                                    placeholder="Please provide any additional notes/information (not required)"></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="loading" type="button" class="btn btn-sm btn-success" disabled>Adding <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-sm btn-success" :disabled="validateForm()"
                            @click="addWaitingRoom()"><i class="fas fa-plus"></i> Add</button>
                        <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'waiting-area-add',
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            loading: false,
            notes: '',
            waitingArea: ''
        }
    },
    methods: {
        addWaitingRoom() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?setWaitingAreasData`;
            const formData = new FormData();

            // Set loading
            this.alert.status = false;
            this.loading = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                notes: this.notes,
                waitingArea: this.waitingArea
            }));
            formData.append('mode', 'setWaitingAreasData');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alert.message = `${that.waitingArea} has been successfully added as a waiting area.`;
                    that.alert.type = "success";

                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alert.message = `${that.waitingArea} could not be added as a waiting area. ${json.message}`;
                    that.alert.type = "warning";
                } else {
                    // Internal error
                    that.alert.message = `${that.waitingArea} could not be added as a waiting area. An error has occurred. Please contact your system administrator.`;
                    that.alert.type = "danger";
                }

                that.refreshData();
                that.alert.status = true;
                that.loading = false;
                that.clearForm();
            }).catch(function () {
                // Internal error
                that.alert.message = `${that.waitingArea} could not be added as a waiting area. An error has occurred. Please contact your system administrator.`;
                that.alert.type = "danger";
                that.alert.status = true;
                that.loading = false;
            })
        },
        clearForm() {
            this.notes = '';
            this.waitingArea = '';
        },
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.alert = {
                message: '',
                status: false,
                type: ''
            };
            this.notes = '';
            this.waitingArea = '';
        },
        validateForm() {
            if (this.waitingArea && this.waitingArea.length >= 2) {
                return false;
            }

            return true;
        }
    }
}
</script>